import S1 from "./S1";
import S2 from "./S2";
import S3 from "./S3";
import S4 from "./S4";
import S5 from "./S5";
import S6 from "./S6";
import S7 from "./S7";
import S8 from "./S8";
import EndCard from "./EndCard";

export const STILLS = {
  s1: { Component: S1, w: 1080, h: 1920 },
  s2: { Component: S2, w: 1080, h: 1920 },
  s3: { Component: S3, w: 1080, h: 1920 },
  s4: { Component: S4, w: 1536, h: 2048 },
  s5: { Component: S5, w: 1536, h: 2048 },
  s6: { Component: S6, w: 1080, h: 1920 },
  s7: { Component: S7, w: 1080, h: 1920 },
  s8: { Component: S8, w: 1080, h: 1920 },
  end_card: { Component: EndCard, w: 1080, h: 1920 },
};
